import {API_URL} from "../../dev";

import "isomorphic-fetch";

class FileApi {
	async getMetaData(id) {
		// Fail fast for images: abort after 3 seconds and return null
		const controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		const timeoutMs = 3000;
		let timeoutId;
		try {
			if (controller) {
				timeoutId = setTimeout(() => controller.abort(), timeoutMs);
			}
			const metaDataResponse = await fetch(`${API_URL}/v1/files/metaData/${id}`, controller ? { signal: controller.signal } : undefined);
			// Clear timeout once fetch resolves
			if (timeoutId) clearTimeout(timeoutId);
			let metaDataObj = null;
			try {
				metaDataObj = await metaDataResponse.json();
			} catch (_) {
				// tolerate non-JSON responses
			}
			if (metaDataResponse.ok) {
				return metaDataObj;
			}
			console.warn(`getMetaData(${id}) returned non-OK status: ${metaDataResponse.status}`);
			return null;
		} catch (e) {
			if (timeoutId) clearTimeout(timeoutId);
			if (e && (e.name === 'AbortError' || e.code === 'ABORT_ERR')) {
				console.warn(`getMetaData(${id}) timed out after ${timeoutMs}ms`);
				return null;
			}
			console.error(`Error occurred in getMetaData ${id}: ${JSON.stringify(e)}`);
			return null;
		}
	}
}
const fileApi = new FileApi();
export default fileApi;
